
//Message directions
export const messageDirections = {
  INCOMING: 'incoming',
  OUTGOING: 'outgoing',
}
